<app-breadcrumb *ngIf="!isWindow" [styleBreadcrumb]="'page-heading'" [title]="'CHAT'" [breadcrumb]="''" [count]=""
    icon="fa-comment-alt-lines">
</app-breadcrumb>
<kendo-splitter #splitterHor (layoutChange)="updateSplitterBars()">
    <kendo-splitter-pane width="300px" [(size)]="verticalPaneSize" [resizable]="true">
        <kendo-splitter #splitterVer orientation="vertical" class="chat-splitter-container"
            (layoutChange)="updateSplitterBars()">
            <kendo-splitter-pane [(size)]="horizontalPaneSize" [ngClass]="{'chat-max-height': chatCollapsed}">
                <ng-template [ngTemplateOutlet]="chatListTemplate" [ngTemplateOutletContext]="{listType: 'CHAT'}">
                </ng-template>
                <div *ngIf="!chatCollapsed" class="ml-3 mr-3">
                    <span *ngIf="!hasChats()" class="montserrat text-center no-chat-text ml-3">
                        {{'NO-CHAT' | translate }}
                    </span>
                    <ul class="list-group">
                        <ng-template [ngTemplateOutlet]="chatItemTemplate" [ngTemplateOutletContext]="{list: chatList}">
                        </ng-template>
                    </ul>
                </div>
            </kendo-splitter-pane>
            <kendo-splitter-pane *ngIf="spaceEnabled" style="height:100vh">
                <ng-template [ngTemplateOutlet]="chatListTemplate" [ngTemplateOutletContext]="{listType: 'SPACE'}">
                </ng-template>
                <div *ngIf="!spaceCollapsed" class="ml-3 mr-3">
                    <span *ngIf="!hasSpaces()" class="montserrat text-center no-chat-text ml-3">
                        {{'NO-SPACES' | translate }}
                    </span>
                    <ul class="list-group">
                        <ng-template [ngTemplateOutlet]="chatItemTemplate"
                            [ngTemplateOutletContext]="{list: spaceList}">
                        </ng-template>
                    </ul>
                </div>
            </kendo-splitter-pane>
        </kendo-splitter>
    </kendo-splitter-pane>
    <kendo-splitter-pane>
        <app-chat-history [isWindow]="isWindow" [windowHeight]="windowHeight"
            [chat]="selectedChat ? selectedChat : null" [users]="users">
        </app-chat-history>
    </kendo-splitter-pane>
</kendo-splitter>

<!--Select Chat/Space users-->
<app-chat-user-selection [createMode]="createMode" [isNew]="isNew" [model]="editChatItem"
    [userDialogOpened]="userSelectionOpened" [allUsers]="activeUsers" (cancelling)="cancel()" (save)="saveChat($event)">
</app-chat-user-selection>

<!--Drop-down menu-->
<ng-template #dropdown let-item='item'>
    <div ngbDropdown>
        <button class="btn btn-outline-primary btn-chat k-text-uppercase" id="dropdownChat"
            attr.aria-label="{{'CHAT-DROPDOWN' | translate}}" ngbDropdownToggle>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownChat" id="chat-drop-down">
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem *ngIf="item.unread"
                (click)="updateUnread(item,false)">
                <i class="fal fa-comment-alt-check fa-header-nav-icon fa-fw"></i>{{'MARK-AS-READ' | translate}}
            </button>
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem *ngIf="!item.unread"
                (click)="updateUnread(item,true)">
                <i class="fal fa-comment-alt-edit fa-header-nav-icon fa-fw"></i>{{'MARK-AS-UNREAD' | translate}}
            </button>
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem *ngIf="item.pinned"
                (click)="updatePinned(item)">
                <kendo-svg-icon [icon]="icons.pin" class="fa-header-nav-icon fa-fw mb-2" style="margin-right: 20px;">
                </kendo-svg-icon>{{'UNPIN' | translate}}
            </button>
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem *ngIf="!item.pinned"
                (click)="updatePinned(item)">
                <kendo-svg-icon [icon]="icons.unpin" class="fa-header-nav-icon fa-fw mb-2" style="margin-right: 20px;">
                </kendo-svg-icon>{{'PIN' | translate}}
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem (click)="leaveChat(item)">
                <i class="fal fa-comment-alt-slash fa-header-nav-icon fa-fw"></i>{{'CHAT-LEAVE' | translate}}
            </button>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item k-text-uppercase" ngbDropdownItem *ngIf="!item.name"
                (click)="manageChatOrSpace(item)">
                <i class="fal fa-users-cog fa-header-nav-icon fa-fw"></i>{{(item.chatSpace ? 'EDIT-SPACE' : 'EDIT-CHAT')
                | translate}}
            </button>
            <div *ngIf="!item.chatSpace" class="dropdown-divider"></div>
            <button *ngIf="!item.chatSpace" class="dropdown-item k-text-uppercase" ngbDropdownItem
                (click)="manageChatOrSpace(item, true)">
                <i class="fal fa-arrow-alt-to-bottom fa-header-nav-icon fa-fw"></i>{{'TURN-CHAT-INTO-SPACE' |
                translate}}
            </button>
        </div>
    </div>
</ng-template>

<!--Chat/Space list template-->
<ng-template #chatListTemplate let-listType="listType">
    <div class="secondary-card-header chat-card-header">
        <h5 class="collapsible-text">
            <div class="row">
                <div class="col-9" (click)="chatCollapsible.toggleChange()" style="display: flex">
                    <app-collapsible #chatCollapsible [storageKey]="listType.toLowerCase()"
                        (collapsibleToggle)="toggleCollapsible(listType, $event)" role="button"
                        attr.aria-label="{{'EXPAND-NAV' | translate}}/{{'COLLAPSE-NAV' | translate}}">
                    </app-collapsible>
                    <span class="ml-2" *ngIf="listType === 'CHAT'">{{'CHAT' | translate}}</span>
                    <span class="ml-2" *ngIf="listType === 'SPACE'">{{'SPACES' | translate}}</span>
                </div>
                <div class="col-3">
                    <i style="position: absolute;right:32px;" title="{{('CREATE-'+listType) | translate}}"
                        class="far fa-plus" (click)="new(listType)" role="button"
                        attr.aria-label="{{('CREATE-'+listType) | translate}}" tabindex="0"
                        (keydown.enter)="new(listType)" (keydown.space)="new(listType)">
                    </i>
                </div>
            </div>
        </h5>
    </div>
</ng-template>

<!--Chat/Space items template-->
<ng-template #chatItemTemplate let-list="list">
    <li class="list-group-item list-group-item-chat pointer" *ngFor="let item of list"
        (click)="chatSelected(item.id, false)"
        [ngClass]="{'active-chat': selectedChat && selectedChat.id === item.id, 'chat-unread-text': item.unread}"
        [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{item: item}">
        <div class="row">
            <div class="col-9 ellipsis-text">{{item.text}}</div>
            <div class="col-3">
                <kendo-svg-icon *ngIf="item.pinned" [icon]="icons.pin"
                    class="fa-header-nav-icon fa-fw mb-2 float-right mr-4">
                </kendo-svg-icon>
            </div>
        </div>
    </li>
</ng-template>

<!--Leave chat/space confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="leaveDialogOpened" (close)="close('leaveDialog')"
    [minWidth]="250" [width]="450">
    <p translate [translateParams]="{type: leaveChatType}">{{'CHAT-LEAVE-CONFIRMATION-TITLE'}}</p>
    <p style="font-size:smaller" translate [translateParams]="{type: leaveChatType}">
        {{'CHAT-LEAVE-CONFIRMATION-DESCRIPTION'}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="close('leaveDialog')">{{ 'CANCEL' | translate }}</button>
        <button kendoButton (click)="leaveAction()" [primary]="true">{{ 'LEAVE' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>